// extracted by mini-css-extract-plugin
var _1 = "ModalContainer-module__container--wtFWC";
var _2 = "ModalContainer-module__content--SeW6C";
var _3 = "ModalContainer-module__inner--eQyIN";
var _4 = "ModalContainer-module__isNextToSidebar--PtqFO";
var _5 = "ModalContainer-module__underlay--id2BB";
export { _1 as "container", _2 as "content", _3 as "inner", _4 as "isNextToSidebar", _5 as "underlay" }
